"use client";

import { useLocale } from "@/hooks/useLocale";
import { motion } from "framer-motion";

export default function PrivacyClient() {
  const { currentLocale } = useLocale();

  return (
    <motion.section
      className="mx-auto max-w-prose mt-32"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <section className="mx-auto max-w-prose px-4 py-12 sm:px-6 sm:py-16">
        {currentLocale === "zh-CN" && (
          <div className="mx-auto max-w-3xl">
            <h1 className="text-3xl leading-8 font-extrabold tracking-tight sm:text-4xl">
              隐私政策
            </h1>
            <article className="prose dark:prose-invert text-base">
              <div>
                <p>生效日期: 2025.07.18</p>
                <p>更新日期: 2025.07.18</p>
                <h2>概述</h2>
                <p>
                  <strong>VPN指南</strong>
                  （以下简称"我们"）非常重视您的隐私保护。本隐私政策说明了我们如何收集、使用、存储和保护您的个人信息。请在使用我们的服务前仔细阅读本政策。
                </p>
                <h2>信息收集</h2>
                <h3>我们收集的信息类型</h3>
                <p>我们可能收集以下类型的信息：</p>
                <ul>
                  <li>
                    <strong>技术信息</strong>
                    ：IP地址、浏览器类型、操作系统、访问时间、页面浏览量等
                  </li>
                  <li>
                    <strong>使用数据</strong>
                    ：您访问的页面、停留时间、点击行为等
                  </li>
                  <li>
                    <strong>设备信息</strong>：设备类型、屏幕分辨率、语言设置等
                  </li>
                  <li>
                    <strong>Cookie数据</strong>
                    ：用于改善用户体验和网站功能的小型文本文件
                  </li>
                </ul>
                <h3>信息收集方式</h3>
                <p>我们通过以下方式收集信息：</p>
                <ul>
                  <li>您主动提供的信息（如联系表单、评论等）</li>
                  <li>自动收集的技术数据</li>
                  <li>第三方分析工具（如Google Analytics）</li>
                  <li>Cookie和类似技术</li>
                </ul>
                <h2>信息使用</h2>
                <h3>使用目的</h3>
                <p>我们使用收集的信息用于以下目的：</p>
                <ul>
                  <li>提供和改进我们的服务</li>
                  <li>分析网站使用情况，优化用户体验</li>
                  <li>提供客户支持和回应您的询问</li>
                  <li>防止欺诈、滥用和非法活动</li>
                  <li>发送服务更新和重要通知</li>
                  <li>遵守法律法规要求</li>
                </ul>
                <h2>信息共享</h2>
                <h3>我们不会出售您的个人信息</h3>
                <p>我们不会向第三方出售、出租或交易您的个人信息。</p>
                <h3>可能的信息共享情况</h3>
                <p>在以下情况下，我们可能会共享您的信息：</p>
                <ul>
                  <li>
                    <strong>服务提供商</strong>
                    ：与帮助我们运营网站的技术服务提供商
                  </li>
                  <li>
                    <strong>法律要求</strong>：当法律要求或政府机构要求时
                  </li>
                  <li>
                    <strong>安全保护</strong>：为保护我们的权利、财产或安全
                  </li>
                  <li>
                    <strong>业务转让</strong>：在公司合并、收购或资产转让时
                  </li>
                </ul>
                <h2>Cookie使用</h2>
                <h3>什么是Cookie</h3>
                <p>
                  Cookie是存储在您设备上的小型文本文件，用于记住您的偏好和改善网站体验。
                </p>
                <h3>我们使用的Cookie类型</h3>
                <ul>
                  <li>
                    <strong>必要Cookie</strong>：网站正常运行所必需
                  </li>
                  <li>
                    <strong>功能Cookie</strong>：记住您的偏好设置
                  </li>
                  <li>
                    <strong>分析Cookie</strong>：帮助我们了解网站使用情况
                  </li>
                  <li>
                    <strong>第三方Cookie</strong>：来自第三方服务提供商
                  </li>
                </ul>
                <h3>Cookie管理</h3>
                <p>
                  您可以通过浏览器设置管理Cookie。请注意，禁用某些Cookie可能会影响网站功能。
                </p>
                <h2>数据安全</h2>
                <h3>安全措施</h3>
                <p>我们采取适当的技术和组织措施来保护您的个人信息：</p>
                <ul>
                  <li>使用加密技术保护数据传输</li>
                  <li>定期更新安全措施</li>
                  <li>限制员工访问个人信息的权限</li>
                  <li>定期进行安全审计</li>
                </ul>
                <h3>数据保留</h3>
                <p>
                  我们仅在实现收集目的所需的时间内保留您的个人信息，或根据法律要求保留。
                </p>
                <h2>您的权利</h2>
                <h3>您享有的权利</h3>
                <p>根据适用法律，您可能享有以下权利：</p>
                <ul>
                  <li>
                    <strong>访问权</strong>：了解我们持有的您的个人信息
                  </li>
                  <li>
                    <strong>更正权</strong>：要求更正不准确或不完整的信息
                  </li>
                  <li>
                    <strong>删除权</strong>：要求删除您的个人信息
                  </li>
                  <li>
                    <strong>限制权</strong>：限制我们处理您的信息
                  </li>
                  <li>
                    <strong>可携带权</strong>：以结构化格式接收您的数据
                  </li>
                  <li>
                    <strong>反对权</strong>：反对我们处理您的信息
                  </li>
                </ul>
                <h3>如何行使权利</h3>
                <p>
                  如果您想行使上述任何权利，请通过我们的联系页面与我们联系。我们将在合理时间内回应您的请求。
                </p>
                <h2>第三方链接</h2>
                <p>
                  我们的网站可能包含指向第三方网站的链接。我们不对这些第三方网站的隐私政策负责。建议您在访问这些网站前查看其隐私政策。
                </p>
                <h2>儿童隐私</h2>
                <p>
                  我们的服务不面向13岁以下的儿童。我们不会故意收集13岁以下儿童的个人信息。如果您认为我们可能收集了儿童的信息，请立即联系我们。
                </p>
                <h2>国际数据传输</h2>
                <p>
                  您的信息可能被传输到您所在国家/地区以外的服务器进行处理。我们将确保这些传输符合适用的数据保护法律。
                </p>
                <h2>政策更新</h2>
                <p>
                  我们可能会不时更新本隐私政策。重大变更将在网站上公布，并更新生效日期。建议您定期查看本政策。
                </p>
                <h2>联系我们</h2>
                <p>
                  如果您对本隐私政策有任何疑问、意见或投诉，请通过以下方式联系我们：
                </p>
                <p>我们致力于保护您的隐私，并将认真处理您的所有询问。</p>
              </div>
            </article>
          </div>
        )}
        {currentLocale === "en-US" && (
          <div className="mx-auto max-w-3xl">
            <h1 className="text-3xl leading-8 font-extrabold tracking-tight sm:text-4xl">
              Privacy Policy
            </h1>
            <article className="prose dark:prose-invert text-base">
              <div>
                <p>Effective Date: 2025.01.27</p>
                <p>Updated Date: 2025.01.27</p>
                <h2>Overview</h2>
                <p>
                  <strong>VPN Guide</strong> (hereinafter referred to as "we")
                  places great importance on protecting your privacy. This
                  Privacy Policy explains how we collect, use, store, and
                  protect your personal information. Please read this policy
                  carefully before using our services.
                </p>
                <h2>Information Collection</h2>
                <h3>Types of Information We Collect</h3>
                <p>We may collect the following types of information:</p>
                <ul>
                  <li>
                    <strong>Technical Information</strong>: IP address, browser
                    type, operating system, access time, page views, etc.
                  </li>
                  <li>
                    <strong>Usage Data</strong>: Pages you visit, time spent,
                    click behavior, etc.
                  </li>
                  <li>
                    <strong>Device Information</strong>: Device type, screen
                    resolution, language settings, etc.
                  </li>
                  <li>
                    <strong>Cookie Data</strong>: Small text files used to
                    improve user experience and website functionality
                  </li>
                </ul>
                <h3>How We Collect Information</h3>
                <p>We collect information through the following methods:</p>
                <ul>
                  <li>
                    Information you actively provide (such as contact forms,
                    comments, etc.)
                  </li>
                  <li>Automatically collected technical data</li>
                  <li>
                    Third-party analytics tools (such as Google Analytics)
                  </li>
                  <li>Cookies and similar technologies</li>
                </ul>
                <h2>Information Use</h2>
                <h3>Purposes of Use</h3>
                <p>
                  We use the collected information for the following purposes:
                </p>
                <ul>
                  <li>Providing and improving our services</li>
                  <li>Analyzing website usage to optimize user experience</li>
                  <li>
                    Providing customer support and responding to your inquiries
                  </li>
                  <li>Preventing fraud, abuse, and illegal activities</li>
                  <li>Sending service updates and important notifications</li>
                  <li>Complying with legal and regulatory requirements</li>
                </ul>
                <h2>Information Sharing</h2>
                <h3>We Do Not Sell Your Personal Information</h3>
                <p>
                  We do not sell, rent, or trade your personal information to
                  third parties.
                </p>
                <h3>Circumstances Where Information May Be Shared</h3>
                <p>
                  We may share your information in the following circumstances:
                </p>
                <ul>
                  <li>
                    <strong>Service Providers</strong>: With technical service
                    providers who help us operate the website
                  </li>
                  <li>
                    <strong>Legal Requirements</strong>: When required by law or
                    government agencies
                  </li>
                  <li>
                    <strong>Security Protection</strong>: To protect our rights,
                    property, or safety
                  </li>
                  <li>
                    <strong>Business Transfers</strong>: In the event of company
                    merger, acquisition, or asset transfer
                  </li>
                </ul>
                <h2>Cookie Usage</h2>
                <h3>What Are Cookies</h3>
                <p>
                  Cookies are small text files stored on your device that help
                  remember your preferences and improve website experience.
                </p>
                <h3>Types of Cookies We Use</h3>
                <ul>
                  <li>
                    <strong>Essential Cookies</strong>: Required for the website
                    to function properly
                  </li>
                  <li>
                    <strong>Functional Cookies</strong>: Remember your
                    preference settings
                  </li>
                  <li>
                    <strong>Analytics Cookies</strong>: Help us understand
                    website usage
                  </li>
                  <li>
                    <strong>Third-Party Cookies</strong>: From third-party
                    service providers
                  </li>
                </ul>
                <h3>Cookie Management</h3>
                <p>
                  You can manage cookies through your browser settings. Please
                  note that disabling certain cookies may affect website
                  functionality.
                </p>
                <h2>Data Security</h2>
                <h3>Security Measures</h3>
                <p>
                  We implement appropriate technical and organizational measures
                  to protect your personal information:
                </p>
                <ul>
                  <li>
                    Using encryption technology to protect data transmission
                  </li>
                  <li>Regularly updating security measures</li>
                  <li>Limiting employee access to personal information</li>
                  <li>Conducting regular security audits</li>
                </ul>
                <h3>Data Retention</h3>
                <p>
                  We retain your personal information only for as long as
                  necessary to fulfill the purposes for which it was collected,
                  or as required by law.
                </p>
                <h2>Your Rights</h2>
                <h3>Rights You May Have</h3>
                <p>Under applicable law, you may have the following rights:</p>
                <ul>
                  <li>
                    <strong>Right of Access</strong>: To know what personal
                    information we hold about you
                  </li>
                  <li>
                    <strong>Right of Rectification</strong>: To request
                    correction of inaccurate or incomplete information
                  </li>
                  <li>
                    <strong>Right of Erasure</strong>: To request deletion of
                    your personal information
                  </li>
                  <li>
                    <strong>Right of Restriction</strong>: To restrict our
                    processing of your information
                  </li>
                  <li>
                    <strong>Right of Portability</strong>: To receive your data
                    in a structured format
                  </li>
                  <li>
                    <strong>Right to Object</strong>: To object to our
                    processing of your information
                  </li>
                </ul>
                <h3>How to Exercise Your Rights</h3>
                <p>
                  If you wish to exercise any of the above rights, please
                  contact us through our contact page. We will respond to your
                  request within a reasonable time.
                </p>
                <h2>Third-Party Links</h2>
                <p>
                  Our website may contain links to third-party websites. We are
                  not responsible for the privacy policies of these third-party
                  websites. We recommend that you review their privacy policies
                  before visiting these sites.
                </p>
                <h2>Children's Privacy</h2>
                <p>
                  Our services are not intended for children under 13 years of
                  age. We do not knowingly collect personal information from
                  children under 13. If you believe we may have collected
                  information from a child, please contact us immediately.
                </p>
                <h2>International Data Transfers</h2>
                <p>
                  Your information may be transferred to servers outside your
                  country/region for processing. We will ensure that these
                  transfers comply with applicable data protection laws.
                </p>
                <h2>Policy Updates</h2>
                <p>
                  We may update this Privacy Policy from time to time.
                  Significant changes will be posted on the website with an
                  updated effective date. We recommend that you review this
                  policy regularly.
                </p>
                <h2>Contact Us</h2>
                <p>
                  If you have any questions, comments, or complaints about this
                  Privacy Policy, please contact us through:
                </p>
                <p>
                  We are committed to protecting your privacy and will handle
                  all your inquiries seriously.
                </p>
              </div>
            </article>
          </div>
        )}
      </section>
    </motion.section>
  );
}
